import React from "react";
import { Presentation } from "../../lib/types";
import { Link } from "react-router-dom";
import { Slide } from "../slide";
import "./presentationList.scss";
import { getPresentUrl } from "../../lib/url-util";

interface PresentationListProps {
	presentations: Presentation[];
}

const PresentationList = (props: PresentationListProps) => {
	return (
		<div className="presentation-list">
			<style>
				:root {"{"} font-size: 1vh; {"}"}{" "}
			</style>
			{props.presentations.map((presentation) => {
				return (
					<Link
						className="presentation-list__item"
						key={presentation.title}
						to={getPresentUrl(presentation.title)}
						title={`${presentation.title}`}
					>
						<div className="presentation-list__title">
							{presentation.title}
						</div>
						<div
							className="presentation-list__preview"
							style={presentation.style}
						>
							<Slide content={presentation.slides[0].content} />
						</div>
					</Link>
				);
			})}
		</div>
	);
};
export { PresentationList };
